// @flow

export const SHIPPING_TYPES = {
	SHIPPING: "SHIPPING",
	PICKUP: "PICKUP",
	MOUNT: "MOUNT"
};

export type ShippingTypes = SHIPPING_TYPES.SHIPPING | SHIPPING_TYPES.PICKUP | SHIPPING_TYPES.MOUNT;
